import React from "react";
import styles from "./LimsStatusBar.module.css";

interface LimsStatusBarProps {
  status: boolean;
}
function LimsStatusBar(props: LimsStatusBarProps) {
  const { status } = props;
  return (
    <div className={styles.container}>
      <span>FIS: </span>
      <p className={status ? styles.success : styles.danger}>
        {status ? "Connected" : "Disconnected"}
      </p>
    </div>
  );
}

export default LimsStatusBar;
